/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const searchToggle = () => {
		$('.js-search-toggle').on('click', function () {
			$(this).toggleClass('is-active');
			$('.js-search-toggleBlock').stop().slideToggle(400);
		});
		$('.js-products-list-toggle').on('click', function () {
			$('.js-products-list-toggleBlock').toggleClass('is-active');
		});
	};
	const morebtn = () => {
		if($('.js-products-detail-featureWrap').length) {
			if(!($('.rt_cf_n_index').text() == 1)) {
				$('.bclo-idx-item-list').css('display','none');
			}
			let pickupLength = 0;
			for(let i=0; i < $('.cf_b_pickup').length; i++) {
				if(!($('.cf_b_pickup').eq(i).text() == 0)) {
					$('.cf_b_pickup').eq(i).parents('.rt_bn_block_list').removeClass('di_none');
				} else {
					pickupLength += 1;
				}
			}
			if(pickupLength == 0) {
				if(!($('.rt_cf_n_index').text() == 1)) {
					$('.bclo-idx-item-list').css('display','none');
				}
			}
			$('.js-products-detail-feature-btn').on('click', function(){
				$('.rt_bn_block_list').removeClass('di_none');
				$(this).addClass('di_none');
				if(!($('.rt_cf_n_index').text() == 1)) {
					$('.bclo-idx-item-list').css('display','none');
				}
			});
		}
		if($('.js-products-detail-designWrap').length) {
			$('.js-products-detail-design-btn').on('click', function(){
				$('.js-products-detail-design-hidden').removeClass('di_none');
				$(this).addClass('di_none');
			});
		}
	};
	const form = () => {
		// パラメータ格納関数
		const pArray = () => {
			let urlParam = location.search.substring(1);
			let paramArray = [];
			if(urlParam) {
				let param = urlParam.split('&');
				for(let i = 0; i < param.length; i++) {
					let paramItem = param[i].split('=');
					paramArray[paramItem[0]] = paramItem[1];
				}
			}
			return paramArray;
		};
		// products/$category$/ページ用
		if($('.js-products-pulldown-series').length) {
			if($('.js-products-pulldown-series').length) {
				const productPulldownseries = $('.js-products-pulldown-series');
				const getJSONproductsformpulldownseries = () => {
					return $.getJSON(`/ajax/products/series.json`);
				};
				let thisTagName = productPulldownseries.attr('name');
				productPulldownseries.css('pointer-events', 'none');
				productPulldownseries.append($('<option>').html('選択してください').val(''));
				getJSONproductsformpulldownseries().then((data) => {
					console.log(data,'getJSONproductsformpulldownseries');
					console.log(data.rt_bn_series_list.length,'getJSONproductsformpulldownseries');
					for(let i = 0; i < data.rt_bn_series_list.length; i++) {
						if(!(pArray()[thisTagName] === data.rt_bn_series_list[i].cf_ps_code)) {
							productPulldownseries.append($('<option>').html(data.rt_bn_series_list[i].cf_ps_name).val(data.rt_bn_series_list[i].cf_ps_code));
						} else {
							productPulldownseries.append($('<option>').html(data.rt_bn_series_list[i].cf_ps_name).val(data.rt_bn_series_list[i].cf_ps_code).prop('selected', true));
						}
					}
					productPulldownseries.css('pointer-events', 'auto');
				});
				if($('.js-products-form').length) {
					$('.js-products-form').attr('action', location.pathname);
				}
				productPulldownseries.change(function(){
					$('.js-products-form').submit();
				});
			}
		}
		// products/$category$/汎用
		if($('.js-products-form-pulldown-series').length) {
			if($('.js-products-form-pulldown-series').length) {
				const productPulldownseries = $('.js-products-form-pulldown-series');
				const getJSONproductsformpulldownseries = () => {
					return $.getJSON(`/ajax/products/series.json`);
				};
				let thisTagName = productPulldownseries.attr('name');
				productPulldownseries.css('pointer-events', 'none');
				productPulldownseries.append($('<option>').html('選択してください').val(''));
				getJSONproductsformpulldownseries().then((data) => {
					// console.log(data,'getJSONproductsformpulldownseries');
					for(let i = 0; i < data.rt_bn_series_list.length; i++) {
						if(!(pArray()[thisTagName] === data.rt_bn_series_list[i].cf_ps_code)) {
							productPulldownseries.append($('<option>').html(data.rt_bn_series_list[i].cf_ps_name).val(data.rt_bn_series_list[i].cf_ps_code));
						} else {
							productPulldownseries.append($('<option>').html(data.rt_bn_series_list[i].cf_ps_name).val(data.rt_bn_series_list[i].cf_ps_code).prop('selected', true));
						}
					}
					productPulldownseries.css('pointer-events', 'auto');
				});
				// productPulldownseries.change(function(){
				// 	$('.js-form').submit();
				// });
			}
		}
		if($('.js-products-form-pulldown-category').length) {
			if($('.js-products-form-pulldown-category').length) {
				const productPulldowncategory = $('.js-products-form-pulldown-category');
				const getJSONproductsformpulldowncategory = () => {
					return $.getJSON(`/ajax/products/category.json`);
				};
				let thisTagName = productPulldowncategory.attr('name');
				productPulldowncategory.css('pointer-events', 'none');
				productPulldowncategory.append($('<option>').html('選択してください').val(''));
				getJSONproductsformpulldowncategory().then((data) => {
					// console.log(data,'getJSONproductsformpulldowncategory');
					for(let i = 0; i < data.rt_bn_category_list.length; i++) {
						if(location.pathname === '/products/list.html') {
							if(!(pArray()[thisTagName] === data.rt_bn_category_list[i].cf_pc_code)) {
								productPulldowncategory.append($('<option>').html(data.rt_bn_category_list[i].cf_pc_name).val(data.rt_bn_category_list[i].cf_pc_code));
							} else {
								productPulldowncategory.append($('<option>').html(data.rt_bn_category_list[i].cf_pc_name).val(data.rt_bn_category_list[i].cf_pc_code).prop('selected', true));
							}
						} else {
							productPulldowncategory.append($('<option>').html(data.rt_bn_category_list[i].cf_pc_name).val(data.rt_bn_category_list[i].cf_pc_code));
						}
					}
					productPulldowncategory.css('pointer-events', 'auto');
				});
				// productPulldowncategory.change(function(){
				// 	$('.js-form').submit();
				// });
			}
		}
	};
	const productslistlabel = () => {
		// パラメータ格納関数
		const pArray = () => {
			let urlParam = location.search.substring(1);
			let paramArray = [];
			if(urlParam) {
				let param = urlParam.split('&');
				for(let i = 0; i < param.length; i++) {
					let paramItem = param[i].split('=');
					paramArray[paramItem[0]] = paramItem[1];
				}
			}
			return paramArray;
		};
		if($('.js-products-list-labelWrap').length) {
			if(pArray()['p_category']) {
				const getJSONcategoryLabel = (category) => {
					return $.getJSON(`/ajax/products/category/${category}.json`);
				};
				getJSONcategoryLabel(pArray()['p_category']).then((data) => {
					// console.log(data.rt_bn_category[0],'getJSONcategoryLabel');
					$('.js-products-list-category-label').attr('href', data.rt_bn_category[0].rt_cf_category_href.href);
					$('.js-products-list-category-label span').text(data.rt_bn_category[0].cf_pc_name);
					$('.js-products-list-category-label').removeClass('di_none');
					$('.js-products-list-labelWrap').removeClass('di_none');
				});
			}
			if(pArray()['p_series']) {
				const getJSONseriesLabel = (series) => {
					return $.getJSON(`/ajax/products/series/${series}.json`);
				};
				getJSONseriesLabel(pArray()['p_series']).then((data) => {
					console.log(data,'getJSONseriesLabel');
					$('.js-products-list-series-label').attr('href', data.rt_bn_series[0].rt_bc_series_href.href);
					$('.js-products-list-series-label span').text(data.rt_bn_series[0].cf_ps_name);
					$('.js-products-list-series-label').removeClass('di_none');
					$('.js-products-list-labelWrap').removeClass('di_none');
				});
			}
		}
	};
	const productdetailpagelink = () => {
		if($('.products-detail .mod-pageLink').length) {
			for(let i = 0; i < $('.products-detail .mod-pageLink li').length; i++) {
				if(!($('.products-detail .mod-pageLink li').eq(i).text())) {
					$('.products-detail .mod-pageLink li').eq(i).remove();
				}
			}
		}
	};
	searchToggle();
	morebtn();
	form();
	productslistlabel();
	productdetailpagelink();

})(window.jQuery, window.FUNCTIONS);
